// @ts-check
/**
 * mapProperties maps the properties of a product.
 * @param {import('../').EquinoxProductProperties} props
 */
function mapProperties(props = {}) {
  /** @type {import('../').EquinoxProductProperties} */
  const properties = {};
  properties.name = mapName(props.name);
  properties.description = mapDescription(props.description);
  properties.productDetailsDescription = mapProductDetailsDescription(props.productDetailsDescription);
  properties.ingredients = mapIngredients(props.ingredients);
  properties.benefits = mapBenefits(props.benefits);
  properties.usage = mapUsage(props.usage);
  properties.scanQualifiedCount = mapScanQualifiedCount(props.scanQualifiedCount);
  properties.division = mapDivision(props.division);
  properties.imageURL = mapImageURL(props.imageURL);
  properties.resources = mapResources(props.resources);
  properties.customerTypes = mapCustomerTypes(props.customerTypes);
  properties.size = mapSize(props.size);

  return properties;
}

/**
 * @param {string|undefined} name 
 * @returns {string}
 */
function mapName(name) {
  if (name) {
    return name;
  }

  return '';
}

/**
 * @param {string|undefined} description 
 * @returns {string}
 */
function mapDescription(description) {
  if (description) {
    return description;
  }

  return '';
}

/**
 * @param {string|undefined} productDetailsDescription 
 * @returns {string}
 */
function mapProductDetailsDescription(productDetailsDescription) {
  if (productDetailsDescription) {
    return productDetailsDescription;
  }

  return '';
}

/**
 * @param {string|undefined} ingredients 
 * @returns {string}
 */
function mapIngredients(ingredients) {
  if (ingredients) {
    return ingredients;
  }

  return '';
}

/**
 * @param {string|undefined} benefits 
 * @returns {string}
 */
function mapBenefits(benefits) {
  if (benefits) {
    return benefits;
  }

  return '';
}

/**
 * @param {string|undefined} usage 
 * @returns {string}
 */
function mapUsage(usage) {
  if (usage) {
    return usage;
  }

  return '';
}

/**
 * @param {string|undefined} scanQualifiedCount 
 * @returns {string}
 */
function mapScanQualifiedCount(scanQualifiedCount) {
  if (scanQualifiedCount) {
    return scanQualifiedCount;
  }

  return '';
}

/**
 * @param {string|undefined} division 
 * @returns {string}
 */
function mapDivision(division) {
  if (division) {
    return division;
  }

  return '';
}

/**
 * @param {string|undefined} imageURL 
 * @returns {string}
 */
function mapImageURL(imageURL) {
  if (imageURL) {
    return imageURL;
  }

  return '';
}

/**
 * @param {string|undefined} resources 
 * @returns {string}
 */
function mapResources(resources) {
  if (resources) {
    return resources;
  }

  return '';
}

/**
 * @param {string|undefined} customerTypes 
 * @returns {string}
 */
function mapCustomerTypes(customerTypes) {
  if (customerTypes) {
    return customerTypes;
  }

  return '';
}

/**
 * @param {string|undefined} size 
 * @returns {string}
 */
function mapSize(size) {
  if (size) {
    return size;
  }

  return '';
}

module.exports = mapProperties;